export default __webpack_public_path__ + "static/media/thumbnail_blog_23.6605bc51.jpg";